import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { useParallax } from '../hooks/useParallax';
import heroSkyline from '../assets/hero-skyline.webp';
import './JobsHero.css';

/**
 * The jobs-list hero: duotone Gulf skyline + headline + search, with one tasteful parallax effect
 * (owner-approved "moderate motion", disabled under prefers-reduced-motion — see useParallax).
 */
export default function JobsHero({ value, onChange }) {
  const parallaxRef = useParallax(0.2);
  const [local, setLocal] = useState(value || '');
  // Only re-sync from the parent when it diverges from our (trimmed) local value — otherwise the
  // parent's trimmed echo of what we just typed would strip a trailing space out from under the
  // user mid-sentence (e.g. typing "welder " before the next word).
  useEffect(() => { if ((value || '') !== local.trim()) setLocal(value || ''); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { const t = setTimeout(() => onChange(local.trim()), 300); return () => clearTimeout(t); }, [local, onChange]);

  return (
    <div className="jhero">
      <img ref={parallaxRef} className="jhero-bg" src={heroSkyline} alt="" role="presentation" />
      <div className="jhero-scrim" />
      <div className="jhero-in container">
        <h1>Your next job in the Gulf starts here</h1>
        <p>Real jobs with real employers, and support at every step — from application to arrival.</p>
        <div className="jhero-search">
          <Search size={18} aria-hidden="true" />
          <input
            type="search"
            inputMode="search"
            aria-label="Search jobs by role or country"
            placeholder="Search jobs by role or country…"
            value={local}
            onChange={(e) => setLocal(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
